/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_Landing_Feature_3Inputs */

const en_service_health_nav_landing_feature_3 = /** @type {(inputs: Service_Health_Nav_Landing_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider guidance`)
};

const fr_service_health_nav_landing_feature_3 = /** @type {(inputs: Service_Health_Nav_Landing_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orientation vers les prestataires`)
};

/**
* | output |
* | --- |
* | "Provider guidance" |
*
* @param {Service_Health_Nav_Landing_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_landing_feature_3 = /** @type {((inputs?: Service_Health_Nav_Landing_Feature_3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_Landing_Feature_3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_landing_feature_3(inputs)
	return fr_service_health_nav_landing_feature_3(inputs)
});